var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M12.25 7h-7m7-3.5h-7m7 7h-7M2.917 7A.583.583 0 1 1 1.75 7a.583.583 0 0 1 1.167 0m0-3.5a.583.583 0 1 1-1.167 0 .583.583 0 0 1 1.167 0m0 7a.583.583 0 1 1-1.167 0 .583.583 0 0 1 1.167 0"
  })));
};
export default SvgList;